import { render } from "./UiDateRangeSelector.vue?vue&type=template&id=6597c67d&scoped=true&ts=true"
import script from "./UiDateRangeSelector.vue?vue&type=script&lang=ts"
export * from "./UiDateRangeSelector.vue?vue&type=script&lang=ts"

import "./UiDateRangeSelector.vue?vue&type=style&index=0&id=6597c67d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6597c67d"]])

export default __exports__